export function dateToLocalDate(date: string): string {
    return new Date(Date.parse(date)).toLocaleDateString();
  }